import styles from './styles.module.scss';
import { WarrantyLogDto } from 'api-new/generated';
import clsx from 'clsx';
import { FC } from 'react';
import { formatDateSafe } from 'utils/formats';

export const LogTable: FC<{ data?: WarrantyLogDto }> = ({ data }) => {
  return (
    <div className="table-responsive">
      <table className={clsx(styles.table, 'table')}>
        <tbody>
          <tr>
            <td>Sent to WA</td>
            <td>
              {formatDateSafe(data?.dateCreate, 'DD/MM/YYYY HH:mm', 'n/a')} - {data?.createUserName ?? 'n/a'}
            </td>
          </tr>
          {Boolean(data?.waDate) && (
            <tr>
              <td>WA Check</td>
              <td>
                {' '}
                {formatDateSafe(data?.waDate, 'DD/MM/YYYY HH:mm', 'n/a')} - {data?.createUserName ?? 'n/a'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
